<template>
  <div class="contact">
    <Header />

    <!-- 背景装饰 -->
    <div class="tech-background"></div>
    <div class="grid-overlay"></div>

    <!-- 移动端布局 -->
    <div class="mobile-layout md:hidden">
      <div class="container mx-auto px-4 pt-32 pb-16">
        <h1 class="page-title text-3xl font-bold mb-12 text-center">
          <span class="title-text">联系我们</span>
          <div class="title-line"></div>
        </h1>

        <!-- 第一部分：联系方式 -->
        <div class="mb-12">
          <div class="glass-card p-6">
            <ul class="space-y-6">
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="ml-4">
                  <h3 class="contact-label">公司地址</h3>
                  <p class="contact-value">江苏省苏州市姑苏区广济南路288号1003室</p>
                </div>
              </li>
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div class="ml-4">
                  <h3 class="contact-label">联系电话</h3>
                  <p class="contact-value">400-96777-26</p>
                </div>
              </li>
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-envelope"></i>
                </div>
                <div class="ml-4">
                  <h3 class="contact-label">电子邮箱</h3>
                  <p class="contact-value">4009677726@chmura.cn</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 第二部分：留言反馈 -->
        <div>
          <div class="glass-card p-6">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item prop="message">
                <el-input type="textarea" v-model="form.message" rows="5" placeholder="请输入您的留言" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm" class="submit-btn w-full">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- PC端布局 -->
    <div class="hidden md:block">
      <div class="container mx-auto px-4 pt-40 pb-20">
        <h1 class="page-title text-5xl font-bold mb-16 text-center">
          <span class="title-text">联系我们</span>
          <div class="title-line"></div>
        </h1>
        
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <!-- 联系方式 -->
          <div class="glass-card p-10 contact-section">
            <h2 class="section-title mb-8">联系方式</h2>
            <ul class="space-y-8">
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div>
                  <h3 class="contact-label">公司地址</h3>
                  <p class="contact-value">江苏省苏州市姑苏区广济南路288号1003室</p>
                </div>
              </li>
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div>
                  <h3 class="contact-label">联系电话</h3>
                  <p class="contact-value">400-96777-26</p>
                </div>
              </li>
              <li class="contact-item">
                <div class="icon-wrapper">
                  <i class="fas fa-envelope"></i>
                </div>
                <div>
                  <h3 class="contact-label">电子邮箱</h3>
                  <p class="contact-value">4009677726@chmura.cn</p>
                </div>
              </li>
            </ul>
          </div>

          <!-- 留言反馈 -->
          <div class="glass-card p-10 contact-section">
            <h2 class="section-title mb-8">留言反馈</h2>
            <el-form ref="form" :model="form" :rules="rules" label-width="0">
              <el-form-item prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item prop="message">
                <el-input type="textarea" v-model="form.message" rows="6" placeholder="请输入您的留言" class="tech-input"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm" class="submit-btn w-full">提交留言</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import BackToTop from '../components/BackToTop.vue';
import { Message } from 'element-ui';

export default {
  name: 'Contact',
  components: {
    Header,
    Footer,
    BackToTop
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: ['blur', 'change'] },
          { min: 2, max: 20, message: '姓名长度在 2 到 20 个字符', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: ['blur', 'change'] }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: ['blur', 'change'] },
          { min: 10, max: 500, message: '留言内容长度在 10 到 500 个字符', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 假的表单提交逻辑
          console.log('表单数据:', this.form);

          // 显示成功提示
          Message.success('提交成功，48小时内将有客户经理与您联系');

          // 重置表单
          this.resetForm();
        } else {
          // 表单验证失败，显示错误提示
          Message.error('请完善所有必填项');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped>
.contact {
  min-height: 100vh;
  position: relative;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1428 100%);
  overflow: hidden;
}

/* 科技感背景 */
.tech-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(ellipse at 20% 30%, rgba(56, 189, 248, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 70%, rgba(147, 51, 234, 0.15) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}

.grid-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(56, 189, 248, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 1;
}

/* 页面标题 */
.page-title {
  position: relative;
  z-index: 2;
  color: #fff;
  text-shadow: 0 0 20px rgba(56, 189, 248, 0.5);
  animation: titleGlow 3s ease-in-out infinite;
}

.title-text {
  display: inline-block;
  background: linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #38bdf8, #a78bfa, transparent);
  margin: 16px auto 0;
  border-radius: 2px;
  animation: lineGlow 2s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% { text-shadow: 0 0 20px rgba(56, 189, 248, 0.5); }
  50% { text-shadow: 0 0 30px rgba(56, 189, 248, 0.8), 0 0 40px rgba(147, 51, 234, 0.4); }
}

@keyframes lineGlow {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

/* 玻璃拟态卡片 */
.glass-card {
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-card:hover {
  transform: translateY(-5px);
  border-color: rgba(56, 189, 248, 0.3);
  box-shadow: 
    0 12px 48px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(56, 189, 248, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.15);
}

/* 区块标题 */
.section-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #38bdf8, #a78bfa);
  border-radius: 2px;
}

/* 联系项目 */
.contact-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.contact-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(56, 189, 248, 0.3);
  transform: translateX(8px);
}

/* 图标容器 */
.icon-wrapper {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(147, 51, 234, 0.2));
  border-radius: 16px;
  border: 1px solid rgba(56, 189, 248, 0.3);
  box-shadow: 
    0 4px 16px rgba(56, 189, 248, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  margin-right: 16px;
}

.contact-item:hover .icon-wrapper {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 
    0 8px 24px rgba(56, 189, 248, 0.4),
    0 0 30px rgba(56, 189, 248, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.2);
}

.icon-wrapper i {
  font-size: 24px;
  background: linear-gradient(135deg, #38bdf8, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 联系信息文字 */
.contact-label {
  font-size: 1rem;
  font-weight: 600;
  color: #38bdf8;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.contact-value {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* 表单输入框样式 */
.contact :deep(.tech-input .el-input__inner),
.contact :deep(.tech-input .el-textarea__inner) {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 15px;
  padding: 14px 18px;
  transition: all 0.3s ease;
}

.contact :deep(.tech-input .el-input__inner::placeholder),
.contact :deep(.tech-input .el-textarea__inner::placeholder) {
  color: rgba(255, 255, 255, 0.4);
}

.contact :deep(.tech-input .el-input__inner:focus),
.contact :deep(.tech-input .el-textarea__inner:focus) {
  background: rgba(255, 255, 255, 0.08);
  border-color: #38bdf8;
  box-shadow: 0 0 20px rgba(56, 189, 248, 0.3);
}

/* 表单项间距 */
.contact :deep(.el-form-item) {
  margin-bottom: 24px;
}

/* 提交按钮 */
.submit-btn {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%);
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(56, 189, 248, 0.4);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 30px rgba(56, 189, 248, 0.6);
}

.submit-btn:hover::before {
  left: 100%;
}

.submit-btn:active {
  transform: translateY(0);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .mobile-layout {
    padding-top: 24px;
  }
  
  .icon-wrapper {
    width: 48px;
    height: 48px;
  }
  
  .icon-wrapper i {
    font-size: 20px;
  }
  
  .contact-label {
    font-size: 0.95rem;
  }
  
  .contact-value {
    font-size: 0.875rem;
  }
}

/* 动画效果 */
.contact-section {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 移除表单错误提示的默认样式影响 */
.contact :deep(.el-form-item__error) {
  color: #ff6b9d;
  font-size: 13px;
  padding-top: 4px;
}
</style>
